import Vue from 'vue'
import Router from 'vue-router'
import RouterIndex from './routerIndex'

Vue.use(Router)

const loginRoute = {
  path: '/login',
  name: 'login',
  component: resolve => require(['@/views/login'], resolve)
}

const submitApplyRoute = {
  path: '/securityCheck/submitApply/:id',
  name: 'submitApply',
  component: resolve => require(['@/views/securityCheck/submitApply'], resolve)
}

const securityCheckRoute = {
  path: '/securityCheck/:id',
  name: 'securityCheck',
  component: resolve => require(['@/views/securityCheck/index'], resolve)
}

const printRoute = {
  path: '/license/print',
  name: 'print',
  component: resolve => require(['@/views/license/print'], resolve)
}

const forgetPasswordRoute = {
  path: '/forgetPassword',
  name: 'forgetPassword',
  component: resolve => require(['@/views/forgetPassword'], resolve)
}
const resetPasswordRoute = {
  path: '/resetPassword',
  name: 'resetPassword',
  component: resolve => require(['@/views/resetPassword'], resolve)
}

const redirectRoute = {
  path: '/',
  redirect: '/workflow'
}

let basicChildrenRoute = [
  {
    path: '/homepage',
    name: 'homepage',
    component: resolve => require(['@/views/index'], resolve),
    meta: { title: '首页' }
  },
  {
    path: '/workflow',
    name: 'workflow',
    component: resolve => require(['@/views/workflow'], resolve),
    meta: { title: '工作中心' }
  },
  {
    path: '/system/user',
    name: 'systemUser',
    component: resolve => require(['@/views/system/user/index'], resolve),
    meta: { title: '用户管理' }
  },
  {
    path: '/system/role',
    name: 'role',
    component: resolve => require(['@/views/system/role/index'], resolve),
    meta: { title: '角色管理' }
  },
  {
    path: '/system/position',
    name: 'position',
    component: resolve => require(['@/views/system/position/index'], resolve),
    meta: { title: '岗位管理' }
  },
  {
    path: '/system/permission',
    name: 'permission',
    component: resolve => require(['@/views/system/permission/index'], resolve),
    meta: { title: '权限管理' }
  },
  {
    path: '/system/department',
    name: 'department',
    component: resolve => require(['@/views/system/department/index'], resolve),
    meta: { title: '部门管理' }
  },
  {
    path: '/system/company',
    name: 'company',
    component: resolve => require(['@/views/system/company/index'], resolve),
    meta: { title: '公司管理' }
  },
  {
    path: '/system/dataDict',
    name: 'dataDict',
    component: resolve => require(['@/views/system/dataDict/index'], resolve),
    meta: { title: '数据字典' }
  },
  {
    path: '/system/snRuleItem',
    name: 'snRuleItem',
    component: resolve => require(['@/views/system/snRuleItem/index'], resolve),
    meta: { title: '流水号规则条目' }
  },
  {
    path: '/system/snRule',
    name: 'snRule',
    component: resolve => require(['@/views/system/snRule/index'], resolve),
    meta: { title: '流水号管理' }
  },
  {
    path: '/system/license',
    name: 'license',
    component: resolve => require(['@/views/system/license/index'], resolve),
    meta: { title: '牌照管理' }
  },
  {
    path: '/system/basicData',
    name: 'basicData',
    component: resolve => require(['@/views/system/basicData/index'], resolve),
    meta: { title: '系统配置' }
  },
  {
    path: '/activiti/process',
    name: 'process',
    component: resolve => require(['@/views/activiti/process/index'], resolve),
    meta: { title: '流程定义' }
  },
  {
    path: '/activiti/runningProcess',
    name: 'runningProcess',
    component: resolve => require(['@/views/activiti/runningProcess/index'], resolve),
    meta: { title: '流程实例管理' }
  },
  {
    path: '/customer',
    name: 'customer',
    component: resolve => require(['@/views/customer/index'], resolve),
    meta: { title: '客户管理' }
  },
  {
    path: '/customer/customerActivity',
    name: 'customerActivity',
    component: resolve => require(['@/views/customer/customerActivity/index'], resolve),
    meta: { title: '客户商务活动' }
  },
  {
    path: '/customer/customerActivity/insert',
    name: 'customerActivityInsert',
    component: resolve => require(['@/views/customer/customerActivity/insert'], resolve),
    meta: { title: '新增客户活动' }
  },
  {
    path: '/customer/customerActivity/update/:id',
    name: 'customerActivityUpdate',
    component: resolve => require(['@/views/customer/customerActivity/update'], resolve),
    meta: { title: '编辑客户活动' }
  },
  {
    path: '/resources/car',
    name: 'carManage',
    component: resolve => require(['@/views/resources/car/carManage'], resolve),
    meta: { title: '车辆预约' }
  },
  {
    path: '/resources/carList',
    name: 'carList',
    component: resolve => require(['@/views/resources/car/carResList'], resolve),
    meta: { title: '我的车辆预约' }
  },
  {
    path: '/resources/carApproval/:id/:processKey/:taskKey',
    name: 'carApproval',
    component: resolve => require(['@/views/resources/car/carApproval'], resolve),
    meta: { title: '车辆预约' }
  },
  {
		  path: '/resources/carApproval/:id',
		  name: 'carApproval',
		  component: resolve => require(['@/views/resources/car/carApproval'], resolve),
		  meta: { title: '车辆预约' }
  },
  {
    path: 'resources/room',
    name: 'roomManage',
    component: resolve => require(['@/views/resources/room/roomManage'], resolve),
    meta: { title: '会议室预约' }
  },
  {
    path: 'resources/roomApproval/:id/:processKey/:taskKey',
    name: 'roomApproval',
    component: resolve => require(['@/views/resources/room/roomApproval'], resolve),
    meta: { title: '会议室预约' }
  },
  {
    path: '/resources/roomList',
    name: 'roomList',
    component: resolve => require(['@/views/resources/room/roomResList'], resolve),
    meta: { title: '我的会议室预约' }
  },
  {
    path: '/tender/notice',
    name: 'tendernNotice',
    component: resolve => require(['@/views/tender/notice/index'], resolve),
    meta: { title: '投标公告' }
  },
  {
    path: '/tender/notice/:id',
    name: 'tendernNoticeDetail',
    component: resolve => require(['@/views/tender/notice/noticeAdd'], resolve),
    meta: { title: '投标公告详情' }
  },
  {
    path: '/tender/noticeNew',
    name: 'tenderNoticeNew',
    component: resolve => require(['@/views/tender/notice/noticeNew'], resolve),
    meta: { title: '投标公告新增' }
  },
  {
    path: '/tender/item/:id/:current',
    name: 'tenderItem',
    component: resolve => require(['@/views/tender/item/index'], resolve),
    meta: { title: '新建项目' }
  },
  {
    path: '/tender/notice/:id/:step',
    name: 'tenderItemDetail',
    component: resolve => require(['@/views/tender/item/indexDetail'], resolve),
    meta: { title: '投标项目详情' }
  },
		 {
		  path: '/tender/notice/:id/:step/:current',
		  name: 'tenderItemDetail',
		  component: resolve => require(['@/views/tender/item/indexDetail'], resolve),
		  meta: { title: '投标项目详情' }
  },
  {
    path: '/tender/workCenter',
    name: 'tenderWorkCenter',
    component: resolve => require(['@/views/tender/workCenter/workCenterList'], resolve),
    meta: { title: '工作中心' }
  },
  {
    path: '/tender/item',
    name: 'tenderItem1',
    component: resolve => require(['@/views/tender/item/index1'], resolve),
    meta: { title: '投标项目' }
  },
  {
    path: '/basic/car',
    name: 'basicCar',
    component: resolve => require(['@/views/resources/car/carIndex'], resolve),
    meta: { title: '车辆管理' }
  },
  {
    path: '/basic/room',
    name: 'basicRoom',
    component: resolve => require(['@/views/basic/room/roomIndex'], resolve),
    meta: { title: '会议室管理' }
  },
  {
    path: '/biz/invoice',
    name: 'bizInvoice',
    component: resolve => require(['@/views/biz/invoice/index'], resolve),
    meta: { title: '发票管理' }
  },
  {
    path: '/biz/invoice/:id',
    name: 'bizInvoiceInfo',
    component: resolve => require(['@/views/biz/invoice/info'], resolve),
    meta: { title: '发票详情' }
  },
  {
		  path: '/biz/invoice/:id/:processKey/:taskKey',
		  name: 'bizInvoiceInfo',
		  component: resolve => require(['@/views/biz/invoice/info'], resolve),
		  meta: { title: '发票详情' }
  },
  {
    path: '/biz/invoice/audit/:id/:type',
    name: 'bizInvoiceAudit',
    component: resolve => require(['@/views/biz/invoice/kaipiao'], resolve),
    meta: { title: '发票审核' }
  },
  {
		  path: '/biz/invoice/audit/:id/:processKey/:taskKey',
		  name: 'bizInvoiceAudit',
		  component: resolve => require(['@/views/biz/invoice/kaipiao'], resolve),
		  meta: { title: '发票审核' }
  },
  {
    path: '/biz/project',
    name: 'bizProject',
    component: resolve => require(['@/views/biz/project/index'], resolve),
    meta: { title: '项目管理' }
  },
  {
    path: '/biz/projectTrace',
    name: 'projectTrace',
    component: resolve => require(['@/views/biz/project/projectTrace'], resolve),
    meta: { title: '项目跟踪' }
  },
  {
    path: '/biz/report/signerReports/:licenseId/:userId/:year',
    name: 'signerReports',
    component: resolve => require(['@/views/biz/project/report/signerReports'], resolve),
    meta: { title: '报告信息' }
  },
  {
    path: '/biz/income',
    name: 'bizIncome',
    component: resolve => require(['@/views/biz/income/index'], resolve),
    meta: { title: '收入管理' }
  },
  {
    path: '/biz/stamp',
    name: 'stamp',
    component: resolve => require(['@/views/biz/stamp/index'], resolve),
    meta: { title: '签章管理' }
  },
  {
    path: '/biz/stamp/:id',
    name: 'stampInfo',
    component: resolve => require(['@/views/biz/stamp/info'], resolve),
    meta: { title: '签章详情' }
  },
  {
		  path: '/biz/stamp/:id/:processKey/:taskKey',
		  name: 'stampInfo',
		  component: resolve => require(['@/views/biz/stamp/info'], resolve),
		  meta: { title: '签章详情' }
  },
  {
    path: '/biz/stamp/audit/:id/:processKey/:taskKey',
    name: 'stampAudit',
    component: resolve => require(['@/views/biz/stamp/audit'], resolve),
    meta: { title: '签章审核' }
  },
		 {
		  path: '/biz/stamp/audit/:id',
		  name: 'stampAudit',
		  component: resolve => require(['@/views/biz/stamp/audit'], resolve),
		  meta: { title: '签章审核' }
  },
  {
    path: '/biz/projectTeamRole',
    name: 'projectTeamRole',
    component: resolve => require(['@/views/biz/projectTeamRole'], resolve),
    meta: { title: '团队角色管理' }
  },
  {
    path: '/biz/busiSource',
    name: 'busiSource',
    component: resolve => require(['@/views/biz/business/bsource'], resolve),
    meta: { title: '业务来源管理' }
  },
  {
    path: '/biz/projectType',
    name: 'bizProjectType',
    component: resolve => require(['@/views/biz/business/ptype'], resolve),
    meta: { title: '项目类型管理' }
  },
  {
    path: '/biz/reportFormula',
    name: 'bizReportFormula',
    component: resolve => require(['@/views/biz/business/formula'], resolve),
    meta: { title: '费用计算公式' }
  },
  {
    path: '/basic/roomOrders',
    name: 'roomOrders',
    component: resolve => require(['@/views/basic/room/roomOrders'], resolve),
    meta: { title: '会议室预约列表' }
  },
  {
    path: '/biz/reportType',
    name: 'bizReportType',
    component: resolve => require(['@/views/biz/business/retype'], resolve),
    meta: { title: '报告类型管理' }
  },
  {
    path: '/biz/contract',
    name: 'bizContract',
    component: resolve => require(['@/views/biz/contract/index'], resolve),
    meta: { title: '合同管理' }
  },
  {
    path: '/biz/projectDetail',
    name: 'projectDetail',
    component: resolve => require(['@/views/biz/project/projectDetail'], resolve),
    meta: { title: '项目详情' }
  },
  {
    path: '/biz/bizQuestion',
    name: 'bizQuestion',
    component: resolve => require(['@/views/biz/business/question'], resolve),
    meta: { title: '评价问题管理' }
  },
  {
    path: '/biz/archiveItem',
    name: 'archiveItem',
    component: resolve => require(['@/views/biz/business/archiveItem'], resolve),
    meta: { title: '归档条目管理' }
  },
  {
    path: '/biz/message',
    name: 'sysMessage',
    component: resolve => require(['@/views/biz/business/message'], resolve),
    meta: { title: '消息管理' }
  },
  {
    path: '/biz/signature',
    name: 'bizSignature',
    component: resolve => require(['@/views/biz/signature/index'], resolve),
    meta: { title: '用印类型管理' }
  },
  {
    path: '/basic/car/audit/:id/:processKey/:taskKey',
    name: 'carAudit',
    component: resolve => require(['@/views/resources/car/carAudit'], resolve),
    meta: { title: '车辆审批' }
  },
  {
    path: '/biz/archive/audit/:id',
    name: 'fileApproval',
    component: resolve => require(['@/views/biz/project/Approval/fileApproval'], resolve),
    meta: { title: '归档审批' }
  },
		 {
		  path: '/biz/archive/audit/:id/:processKey/:taskKey',
		  name: 'fileApproval',
		  component: resolve => require(['@/views/biz/project/Approval/fileApproval'], resolve),
		  meta: { title: '归档审批' }
  },
  {
    path: '/biz/report/:id/:processKey/:taskKey',
    name: 'reportApproval',
    component: resolve => require(['@/views/biz/project/Approval/reportApproval'], resolve),
    meta: { title: '报告审批' }
  },
  {
		  path: '/biz/report/:id',
		  name: 'reportApproval',
		  component: resolve => require(['@/views/biz/project/Approval/reportApproval'], resolve),
		  meta: { title: '报告审批' }
  },
  {
    path: '/biz/tender1/audit/:id/:processKey/:taskKey',
    name: 'tender1',
    component: resolve => require(['@/views/biz/tender/tender1'], resolve),
    meta: { title: '投标报名审批' }
  },
  //     {
  //       path: '/biz/tender1/:id',
  //       name: 'tender1',
  //       component: resolve => require(['@/views/biz/tender/tender1Detail'], resolve),
  //       meta: {title: '投标报名审批查看'}
  //     },
  {
    path: '/biz/tender2/audit/:id/:processKey/:taskKey',
    name: 'tender2',
    component: resolve => require(['@/views/biz/tender/tender2'], resolve),
    meta: { title: '投标缴纳保证金审批' }
  },
  //     {
  //       path: '/biz/tender2/:id',
  //       name: 'tender2',
  //       component: resolve => require(['@/views/biz/tender/tender2Detail'], resolve),
  //       meta: {title: '投标缴纳保证金审批查看'}
  //     },
  {
    path: '/biz/tender6/audit/:id/:processKey/:taskKey',
    name: 'tender6',
    component: resolve => require(['@/views/biz/tender/tender6'], resolve),
    meta: { title: '中标服务费审批' }
  },
  //     {
  //       path: '/biz/tender6/:id',
  //       name: 'tender6',
  //       component: resolve => require(['@/views/biz/tender/tender6Detail'], resolve),
  //       meta: {title: '投标缴纳中标服务费审批查看'}
  //     },
  {
    path: '/biz/projectBonus',
    name: 'projectBonus',
    component: resolve => require(['@/views/biz/projectBonus/index'], resolve),
    meta: { title: '项目奖金分配' }
  },
  {
    path: '/biz/bonusAccount',
    name: 'bonusAccount',
    component: resolve => require(['@/views/biz/bonusAccount/index'], resolve),
    meta: { title: '项目奖金核算' }
  },
  {
    path: '/biz/projectBonus/:id',
    name: 'projectBonusDetail',
    component: resolve => require(['@/views/biz/projectBonus/detail'], resolve),
    meta: { title: '项目奖金分配明细' }
  },
  {
    path: '/biz/personBonus',
    name: 'personBonus',
    component: resolve => require(['@/views/biz/personBonus/index'], resolve),
    meta: { title: '个人薪酬' }
  },
  {
    path: '/biz/personBonus/:id',
    name: 'personBonusDetail',
    component: resolve => require(['@/views/biz/personBonus/detail'], resolve),
    meta: { title: '个人薪酬明细' }
  },
  {
    path: '/personal/personalCenter',
    name: 'personalCenter',
    component: resolve => require(['@/views/personal/personalCenter'], resolve),
    meta: { title: '个人中心' }
  },
  {
    path: '/biz/expend',
    name: 'bizExpend',
    component: resolve => require(['@/views/biz/income/expend'], resolve),
    meta: { title: '支出管理' }
  },
  {
    path: '/biz/archivesLend/:type/:id/:processKey/:taskKey',
    name: 'bizArchive',
    component: resolve => require(['@/views/biz/archive/archiveOperate'], resolve),
    meta: { title: '档案借阅申请' }
  },
  {
    path: '/resources/overtime/:type/:id/:processKey/:taskKey',
    name: 'overtimeApply',
    component: resolve => require(['@/views/resources/overtime/overtimeOperate'], resolve),
    meta: { title: '加班申请' }
  },
  {
    path: '/biz/filing/audit/:id/:processKey/:taskKey',
    name: 'auditReportFiling',
    component: resolve => require(['@/views/filing/auditReportFilingApproval'], resolve),
    meta: { title: '报告信息核对' }
  },
  {
    path: '/workflow/monitor',
    name: 'workflowMonitor',
    component: resolve => require(['@/views/workflow/monitor/index'], resolve),
    meta: { title: '流程监控' }
  },
]

const addRoute = function() {
  basicChildrenRoute = basicChildrenRoute.concat(RouterIndex.basicChildren)
  return basicChildrenRoute
}

const basicRoute = {
  path: '/',
  component: resolve => require(['@/views/framework/index'], resolve),
  children: addRoute()
}

const questionRoute =
  {
    path: '/questionnaire',
    name: 'questionnaire',
    component: resolve => require(['@/views/biz/project/evaluate/questionnaire'], resolve),
    meta: { title: '问卷调查' }
  }

const routes = [
  redirectRoute,
  submitApplyRoute,
  loginRoute,
  printRoute,
  forgetPasswordRoute,
  resetPasswordRoute,
  basicRoute,
  questionRoute,
  securityCheckRoute
]

const router = new Router({
  routes: routes
})

router.beforeEach((to, from, next) => {
  if (to.fullPath == '/login' || to.path == '/oa/help/question/2/1' || to.path == '/questionnaire' || to.path == '/questionApp' || to.path == '/forgetPassword' || to.path == '/resetPassword' || to.name == 'securityCheck' || to.name == 'submitApply') {
    next()
  } else {
    if (sessionStorage.getItem('token')) {
      next()
    } else {
      next('/login')
    }
  }
  // iView.LoadingBar.start();
  // Util.title(to.meta.title);
  // if (Cookies.get('locking') === '1' && to.name !== 'locking') { // 判断当前是否是锁定状态
  //   iView.LoadingBar.finish();
  //   next(false);
  //   router.push({
  //     name: 'locking'
  //   });
  // } else if (Cookies.get('locking') === '0' && to.name === 'locking') {
  //   iView.LoadingBar.finish();
  //   next(false);
  // } else {
  //   //1.处理第一次加载
  //   let isFirstLoad = store.getters.framework_firstLoad;
  //   if (isFirstLoad) {
  //     store.dispatch('authUpdateMenu', {
  //       'router': router,
  //       'curr': to
  //     });
  //     store.dispatch('frameworkUpdateFirstLoad');
  //   }
  //   next();
  // }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js